(function () {
	const header = () => {
		const header = document.querySelector('.c-header');
		const headerLogo = document.querySelector('.c-header__link');
		const headerBtnBox = document.querySelectorAll('.c-header__btn-box');
		const headerSearch = document.querySelector('.c-header__icon-btn--search');
		const headerSearchDim = document.querySelector('.c-header__dim');
		const searchBox = headerSearch.closest('.c-header__icon-box');
		const searchWrap = searchBox.querySelector('.c-header__search-wrap');

		let prvScrollY = 0;
		const setSearchOpen = (isOpen, restoreFocus = false) => {
			searchBox.classList.toggle('c-header__icon-box--active', isOpen);
			headerSearch.setAttribute('aria-expanded', String(isOpen));
			searchWrap.setAttribute('aria-hidden', String(!isOpen));
			searchWrap.inert = !isOpen;
			scrollSet.otherLenisScroll('.c-header__search-wrap', isOpen);

			if(isOpen) {
				const searchInput = document.getElementById('Search-In-Modal-1');
				if(searchInput) searchInput.focus();
			} else if(restoreFocus) {
				headerSearch.focus();
			}
		}
		const setFoldHeight = (parent, set) => {
			const fold = parent.querySelector('.c-header__fold');
			const foldBody = fold.querySelector('.c-header__body');
			const btn = parent.querySelector('.c-header__btn');

			if(searchBox.classList.contains('c-header__icon-box--active')) {
				setSearchOpen(false, searchWrap.contains(document.activeElement));
			}
			if(set === 0) {
				parent.classList.remove('c-header__btn-box--active');
				fold.style.maxHeight = 0 + "px";
				fold.style.height = 0 + "px";
				fold.setAttribute('aria-hidden', 'true');
				fold.inert = true;
			} else {
				parent.classList.add('c-header__btn-box--active');
				fold.style.maxHeight = foldBody.scrollHeight + 80 + "px";
				fold.style.height = foldBody.scrollHeight + 80 + "px";
				fold.setAttribute('aria-hidden', 'false');
				fold.inert = false;
			}
			if(btn) {
				btn.setAttribute('aria-expanded', set === 0 ? 'false' : 'true');
			}
		}
		const headerActive = (active) => {
			if(active == 'active') {
				header.classList.add('c-header--active');
			} else {
				header.classList.remove('c-header--active');
			}
		}
		headerBtnBox.forEach(box => {
			const btn = box.querySelector('.c-header__btn');
			box.addEventListener('mouseenter', () => setFoldHeight(box, 1));
			box.addEventListener('mouseleave', () => {
				// Keep the fold open only for keyboard focus (:focus-visible);
				// a mouse click also focuses the button, but must not pin the
				// menu open after the pointer leaves.
				const active = document.activeElement;
				if(!box.contains(active) || !active.matches(':focus-visible')) setFoldHeight(box, 0);
			});
			box.addEventListener('focusout', (e) => {
				if(!box.contains(e.relatedTarget)) setFoldHeight(box, 0);
			});

			if(btn) {
				box.addEventListener('keydown', (e) => {
					if(e.target === btn && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) {
						e.preventDefault();
						const isOpen = box.classList.contains('c-header__btn-box--active');
						setFoldHeight(box, isOpen ? 0 : 1);
					} else if(e.key === 'Escape' && box.classList.contains('c-header__btn-box--active')) {
						e.preventDefault();
						setFoldHeight(box, 0);
						btn.focus();
					}
				})
			}
		})
		headerLogo.addEventListener('focusin', () => headerActive('active'));

		// scroll 
		window.addEventListener('scroll', () => {
			let currentScrollY = window.scrollY;
			// 50px 이상 스크롤시
			if(window.scrollY > 50) {
				header.classList.add('c-header--active');
			} else {
				header.classList.remove('c-header--active');
				header.classList.remove('c-header--down');
			}
			
			// 스크롤 올릴때
			if(window.scrollY > 50) {
				if(window.scrollY < prvScrollY) {
					header.classList.remove('c-header--down');
				} else {
					header.classList.add('c-header--down');
				}
			}
			prvScrollY = currentScrollY;
		})
		headerSearch.addEventListener('click', () => {
			setSearchOpen(!searchBox.classList.contains('c-header__icon-box--active'));
		})
		headerSearchDim.addEventListener('click', () => {
			if(searchBox.classList.contains('c-header__icon-box--active')) setSearchOpen(false);
		})
		document.addEventListener('keydown', (e) => {
			if(e.key !== 'Escape') return;
			if(searchBox.classList.contains('c-header__icon-box--active')) {
				setSearchOpen(false, true);
			}
		})
		const cSearch = document.querySelectorAll('.c-search > input');
		const cSearchDelete = document.querySelectorAll('.c-search__delete');
		if(cSearch) {
			cSearch.forEach(input => {
				const searchBox = input.closest('.c-search');
				input.addEventListener('input', () => {
					if(input.value.length > 0) {
						searchBox.classList.add('c-search--active');
					} else {
						searchBox.classList.remove('c-search--active');
					}
				})
			})
			cSearchDelete.forEach(del => {
				const searchBox = del.closest('.c-search');
				const searchInput = searchBox.querySelector('.c-search > input');
				del.addEventListener('click', () => {
					searchInput.value = ""
					searchBox.classList.remove('c-search--active');
				})
			})
		}
		const mypageBtn = document.querySelector('.c-header__icon-btn--mypage');
		const headerDropBox = mypageBtn.closest('.c-header__drop-box');
		const accountDrop = headerDropBox.querySelector('.c-header__drop');
		const hasAccountDrop = !!accountDrop;
		const setAccountOpen = (isOpen, restoreFocus = false) => {
			if(!hasAccountDrop) return;
			headerDropBox.classList.toggle('c-header__drop-box--active', isOpen);
			mypageBtn.setAttribute('aria-expanded', String(isOpen));
			accountDrop.setAttribute('aria-hidden', String(!isOpen));
			accountDrop.inert = !isOpen;
			if(restoreFocus) mypageBtn.focus();
		}
		if(mypageBtn) {
			mypageBtn.addEventListener('click', () => {
				if(hasAccountDrop) {
					setAccountOpen(!headerDropBox.classList.contains('c-header__drop-box--active'));
				}
			})
			if(hasAccountDrop) {
				headerDropBox.addEventListener('keydown', (e) => {
					if(e.key === 'Escape' && headerDropBox.classList.contains('c-header__drop-box--active')) {
						e.preventDefault();
						setAccountOpen(false, true);
					}
				})
			}
		}
		document.addEventListener('click', (e) => {
			if(headerDropBox.classList.contains('c-header__drop-box--active') && !headerDropBox.contains(e.target)) {
				setAccountOpen(false);
			}
		})

		const headerCart = document.querySelector('.c-header__icon-btn--cart');
		if(!headerCart) return;
		const headerDrawer = document.querySelector('.drawer');
		if(!headerDrawer) return;

		headerCart.addEventListener('click', () => {
			if(headerDrawer.classList.contains('active')) {
				scrollSet.otherLenisScroll('.drawer', false);
			} else {
				scrollSet.otherLenisScroll('.drawer', true);
			}
		})
		if(headerDrawer.classList.contains('active')) {
			console.log('111')
			scrollSet.otherLenisScroll('.drawer', false);
		} else {
			scrollSet.otherLenisScroll('.drawer', true);
		}
	}

	document.addEventListener('shopify:section:load', header);
	header();
})();
